import { AlertTriangle, Mail, MailOpen, MessageSquare } from "lucide-react";

import KpiCard from "@/app/admin/_common/KpiCard";
import type { CommunicationsStats } from "@/app/_services/CommunicationsService";

function percent(part: number, whole: number) {
  if (!whole) return "";
  return ` (${Math.round((part / whole) * 100)}%)`;
}

export default function CommunicationsKpiRow({
  stats,
}: {
  stats: CommunicationsStats | null;
}) {
  const isLoading = stats === null;

  return (
    <div className="grid grid-cols-2 gap-2.5 sm:gap-3 lg:grid-cols-4">
      <KpiCard
        label="Emails sent"
        value={isLoading ? "" : String(stats.email_sent)}
        trendPct={null}
        icon={Mail}
        isLoading={isLoading}
        tooltip="Every email handed to Postmark in the last 30 days — transactional, automation and campaign."
      />
      <KpiCard
        label="Emails opened"
        value={
          isLoading
            ? ""
            : `${stats.email_opened}${percent(stats.email_opened, stats.email_sent)}`
        }
        trendPct={null}
        icon={MailOpen}
        isLoading={isLoading}
        tooltip="Opens are undercounted by design: many mail clients block the tracking pixel, and a click still counts as an open."
      />
      <KpiCard
        label="Texts sent"
        value={isLoading ? "" : String(stats.sms_sent)}
        trendPct={null}
        icon={MessageSquare}
        isLoading={isLoading}
        tooltip="SMS handed to Twilio in the last 30 days."
      />
      <KpiCard
        label="Didn't arrive"
        value={isLoading ? "" : String(stats.email_problem + stats.sms_problem)}
        trendPct={null}
        icon={AlertTriangle}
        isLoading={isLoading}
        tooltip="Bounces and spam reports on the email side, carrier rejections and failures on the SMS side."
      />
    </div>
  );
}
